import React, { useState } from 'react';
import Row from '../layout/row';
import Grid from '../layout/grid';

const ImagemZoom = ({ src, alt }) => {
    const [showModal, setShowModal] = useState(false);
    const [zoom, setZoom] = useState(50);

    const abrirModal = () => {
        setZoom(1); // Resetar zoom
        setShowModal(true);
    };

    const mobile = window.innerWidth < 800;

    return (
        <div style={{ backgroundColor: '#f0f0f0', padding: 8 }}>
            <Row alignCenter>
                <div
                    onWheel={(e) => {
                        // // Zoom in/out se o botão do meio for usado (scroll)
                        // e.preventDefault();
                        // const zoomChange = e.deltaY < 0 ? 10 : -10; // scroll pra cima = zoom in
                        // setZoom(Math.max(10, zoom + zoomChange))
                    }}
                    style={{  }}>
                    <img
                        style={
                            mobile ? {
                                maxWidth: '90%',
                                maxHeight: (300 * zoom) / 100,
                                width: 'auto',
                                height: 'auto',
                                margin: 12
                            } : {
                                maxWidth: '90%',
                                height: (300 * zoom) / 100,
                                width: 'auto',
                                margin: 12
                            }
                        }
                        src={src} />
                </div>
            </Row>
            {src &&
                <Row alignCenter style={{ marginBottom: 16 }}>
                    <Grid cols='12 12 8 6'>
                        <Row alignCenter>
                            <div class='col-6 col-xs-6 col-sm-6 col-md-6 col-lg-6' style={{ maxWidth: 80 }}>
                                <button type='button' class='btn btn-block btn-lg btn-dark'
                                    onClick={() => setZoom(Math.max(10, zoom - 20))}>
                                    <i class='fas fa-search-minus' style={{ fontSize: 18 }}></i>
                                </button>
                            </div>
                            <div class='col-6 col-xs-6 col-sm-6 col-md-6 col-lg-6' style={{ maxWidth: 80 }}>
                                <button type='button' class='btn btn-block btn-lg btn-dark'
                                    onClick={() => setZoom(Math.max(10, zoom + 20))}>
                                    <i class='fas fa-search-plus' style={{ fontSize: 18 }}></i>
                                </button>
                            </div>
                        </Row>
                    </Grid>
                </Row>}
        </div>
    );
};

export default ImagemZoom;
